/*
 * uploadWidgetController
 * */
import { CELL_DATA_TYPES } from '../../../common/table/tableWrap/cellDataType';

class uploadWidgetController {
	
    constructor($log, dashboardService, appI18n, $filter, appSession, $state, appConfig, $scope,
		userService, $q, sideNavigationService
	) {
		'ngInject';
		
		this.$log = $log;
		this.dashboardService = dashboardService;
		this.appI18n = appI18n;
		this.$filter = $filter;
		this.appSession = appSession;
		this.$state = $state;
		this.appConfig = appConfig;
		this.$scope = $scope;
		this.userService = userService;
		this.sideNavigationService = sideNavigationService;
		this.$q = $q;
	}

	async $onInit() {
		this.$log = this.$log.getInstance('uploadWidgetController');
		this.$log.debug('loaded');
		this.isLoading = false;
		this.displayContent = true;
		
		await this.initializeNavigationPermissions();
		
		this.getTransmittalData();
		this.headers = this.getuploadWidgetTableHeaders();
	}

	async $onChanges() {
		await this.initializeNavigationPermissions();
		this.widgetControls = await this.getWidgetControls();
	}

	openDataEntryModule(mode) {
		this.$state.go(this.appConfig.routes.cdePftNewEntry, { 'signKey': null, 'tokenId': null, 'cdeMode': mode });
	}

	openCardiacUploadModule(uploadType) {
		this.$state.go(this.appConfig.routes.cardiacUpload, { 'cduMode': uploadType });
	}

	getuploadWidgetTableHeaders() {
		return [{
			value: 'dashboard.transmittal-data.site-investigator',
			type: CELL_DATA_TYPES.TEXT
		}, {
			value: 'dashboard.transmittal-data.submission-digital',
			type: CELL_DATA_TYPES.TEXT
		}, {
			value: 'dashboard.transmittal-data.submission-paper',
			type: CELL_DATA_TYPES.TEXT
		}];
	}
	filterUploadWidgetItems(uploadWidgetItems) {
		if (!uploadWidgetItems || uploadWidgetItems.length === 0) {
			return;
		}
		const visibleItems = uploadWidgetItems.filter((item) => {
			return item.isSectionVisible > 0;
		});

		if (!visibleItems || visibleItems.length === 0) {
			this.widgetControls = null;
			return;
		}

		// Filter widgetControls based on visibleItems
		this.widgetControls.controls = this.widgetControls.controls.filter(ctrl =>
			visibleItems.some(item => item.sectionDescription === ctrl.displayName)
		);

       // Update displayName for matched items
		this.widgetControls.controls.forEach(ctrl => {
			const match = visibleItems.find(item => item.sectionDescription === ctrl.displayName);
			if (match) {
				ctrl.displayName = match.sectionLabel;
			}
		});
			

	}
	getTransmittalData() {
		this.isLoading = true;
		let totalPaperCount = 0;
		let totalDigitalCount = 0;
		this.dashboardService.getTransmittalData().then((data) => {
			this.transmittalData = data.response;
			this.isSponsor = data.isSponsorUser;
			if (data.uploadWidgetItems && data.uploadWidgetItems.length > 0) {
				this.filterUploadWidgetItems(data.uploadWidgetItems);
			} else {
				this.widgetControls = null;
			}
			
			if (this.transmittalData.length > 0) {
				angular.forEach(this.transmittalData, (value) => {
					totalPaperCount = Number(totalPaperCount) + Number(value.paperSubmissionCount);
					totalDigitalCount = Number(totalDigitalCount) + Number(value.digitalSubmissionCount);
				});

				angular.forEach(this.transmittalData, () => {
					this.transmittalData.sort((a, b) => {
						const percentagePaper = (Number(a.paperSubmissionCount) /
							(Number(a.paperSubmissionCount) + Number(a.digitalSubmissionCount))) * 100;
						const percentageDigital = (Number(b.paperSubmissionCount) /
							(Number(b.paperSubmissionCount) + Number(b.digitalSubmissionCount))) * 100;
						return Number(percentageDigital) - Number(percentagePaper);
					});
				});

				this.Total = {
					sponsorSiteId: 'Total',
					paperSubmissionCount: totalPaperCount,
					digitalSubmissionCount: totalDigitalCount
				};
			}
			
			if (this.transmittalData.length > 5) {
				this.transmittalData = this.transmittalData.slice(0, 5);
			}
			
			this.noDataText = {
				sponsorSiteId: 'No data available.',
				paperSubmissionCount: '',
				digitalSubmissionCount: ''
			};

			const defers = this.$q.all([
				this.userService.getUserIsInternal()
			]);
			defers.then(resolves => {
				const userIsInternal = resolves[0];
				if ((userIsInternal || this.isSponsor) && this.transmittalData.length > 0) {
					this.transmittalData.push(this.Total);
				} else if (this.transmittalData.length === 0) {
					this.transmittalData.push(this.noDataText);
				}
			});
			

			this.isLoading = false;
		}, (error) => {
			this.isLoading = false;
			this.queryErrorMessage = this.appI18n.translateImmediate('dashboard.loading-error');
			this.$log.error(`error in getting dashboard Transmittal data: ${error}`);
		});
	}

	getWidgetControls() {
		return {
			type: 'button',
			cssClass: '',
			disabled: false,
			displayName: this.appI18n.translateImmediate('dashboard.transmittal-data.new-upload'),
			controls: this.getSubControls()
		};
	}

	getSubControls() {
		
		const uploadOption = {
			type: 'button',
			cssClass: 'es-icon es-icon-create-trans',
			disabled: false,
		};

		const digitalEcgUpload = {
			...uploadOption,
			displayName: this.appI18n.translateImmediate('dashboard.transmittal-data.digital-ecg-upload'),
			action: () => {
				this.openCardiacUploadModule(this.appConfig.cduMode.Ecg);
			}
		};

		const digitalRespitoryUpload = {
			...uploadOption,
			displayName: this.appI18n.translateImmediate('dashboard.transmittal-data.digital-respitory-upload'),
			action: () => {
				this.openCardiacUploadModule(this.appConfig.cduMode.Respiratory);
			}
		};

		const paperEcgUpload = {
			...uploadOption,
			displayName: this.appI18n.translateImmediate('dashboard.transmittal-data.paper-ecg-upload'),
			action: () => {
				this.openDataEntryModule(this.appConfig.cdeMode.Ecg);
			}
		};

		const paperRespitoryUpload = {
			...uploadOption,
			displayName: this.appI18n.translateImmediate('dashboard.transmittal-data.paper-respitory-upload'),
			action: () => {
				this.openDataEntryModule(this.appConfig.cdeMode.Pft);
			}
		};

		const controls = [];

		if (this.cardiacUploadEnabled) {
			controls.push(digitalEcgUpload);
			controls.push(digitalRespitoryUpload);
		}
		
		if (this.cdePftListEnabled) {
			controls.push(paperEcgUpload);
			controls.push(paperRespitoryUpload);
		}
		
		return controls;
	}

	async initializeNavigationPermissions() {
		try {
			const navigationItems = await this.sideNavigationService.getNavigationItems();
			
			this.cdePftListEnabled = false;
			this.cardiacUploadEnabled = false;
			
			this.navItems = navigationItems;
			this.navItems.forEach((item) => {
				if (item.routeRoot === this.appConfig.routes.cdePftList) {
					this.cdePftListEnabled = true;
				}
				if (item.routeRoot === this.appConfig.routes.cardiacUpload) {
					this.cardiacUploadEnabled = true;
				}
			});
			
		} catch (error) {
			this.$log.error('Failed to initialize navigation permissions:', error);
			this.cdePftListEnabled = false;
			this.cardiacUploadEnabled = false;
		}
	}

	isDataEntryEnabled() {
		return Promise.resolve({
			cdePftList: this.cdePftListEnabled,
			cardiacUpload: this.cardiacUploadEnabled,
			isEnabled: this.editIconEnabled
		});
	}
}

export default uploadWidgetController;
